import { Modal } from '@quickbit/qb-design-system';

interface Props {
  isOpen: boolean;
  status: 'success' | 'error';
  buttonOnClick: () => void;
}

export const PasswordResetModal = ({
  isOpen,
  status,
  buttonOnClick,
}: Props) => {
  if (!isOpen) return null;

  if (status === 'error') {
    return (
      <Modal
        title="Oops!"
        subtitle="Something went wrong, please try again."
        primaryButtonProps={{
          text: 'Try again',
          onClick: buttonOnClick,
        }}
      />
    );
  }

  return (
    <Modal
      title="Check your email"
      subtitle="We have sent a reset password link to the email you entered."
      primaryButtonProps={{
        text: 'Got it!',
        onClick: buttonOnClick,
      }}
    />
  );
};
